var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-main" },
    [
      _c("img", { staticClass: "logo", attrs: { src: _vm.images.logo } }),
      _c(
        "div",
        { staticClass: "login" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-position": "top",
                "label-width": "100px",
                model: _vm.form,
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sign_in.email"),
                    prop: "email",
                    clearable: "",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sign_in.password"),
                    prop: "password",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "password", clearable: "" },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.signInLoading },
                  on: { click: _vm.signIn },
                },
                [_vm._v(_vm._s(_vm.$t("sign_in.signin")))]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-menu",
                { staticClass: "options" },
                [
                  _c(
                    "el-menu-item",
                    {
                      staticStyle: { "padding-left": "0" },
                      attrs: { index: "1" },
                    },
                    [
                      _c("router-link", { attrs: { to: { name: "forgot" } } }, [
                        _vm._v(_vm._s(_vm.$t("sign_in.forgot_password"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "center" } },
        [
          _c(
            "el-menu",
            { attrs: { mode: "horizontal" } },
            [
              _c("el-menu-item", { attrs: { index: "1" } }, [
                _c("a", { attrs: { href: "/terms" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.terms"))),
                ]),
              ]),
              _c("el-menu-item", { attrs: { index: "2" } }, [
                _c("a", { attrs: { href: "/privacy" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.privacy"))),
                ]),
              ]),
              _c("el-menu-item", { attrs: { index: "3" } }, [
                _c("a", { attrs: { href: "https://cuona.io/contact" } }, [
                  _vm._v(_vm._s(_vm.$t("footer_menus.contact"))),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }